import { reactive, ref, computed, watch, watchEffect } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import * as apiNote from '@/api/note'
import * as apiCommon from '@/api/common'
import { getDataURL } from '@/util/common'

/**
 * 一覧画面で表示するノートの選択ウィンドウ
 * 用途：QA一覧画面、ナレッジ一覧画面
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    // 一覧データ（データバインディング用）
    list: [],

    /**
     * データロード発動
     * startLoading=trueになった時にloadData()メソッドを実行する
     */
    startLoading: watch(() => {
      if (props.startLoading) {
        group1.loadData()
      }
    }),

    /**
     * 表示用データをロードする
     */
    loadData: () => {

      // ノート一覧APIをコール
      const params = {}
      params.start = 0
      params.per_page = 0
      if (props.type === 'qa') {
        params.qa_id = props.typeId
      } else if (props.type === 'knowledge') {
        params.knowledge_id = props.typeId
      }
      params.pagenate_flg = 1 // 検索履歴に保存しない

      apiNote.list(params)
        .then(response => {
          if (response) {
            const { data } = response

            // 作業変数listWorkに対して画像データimageを追加してから、group1.listに設定する。
            // そうしないと、imageがリアクティブにならず値の変化が検知されない。
            const listWork = data.lists ?? []
            for (let i = 0; i < listWork.length; i++) {
              listWork[i].image = null
            }
            
            for (let i = 0; i < listWork.length; i++) {
              const id = listWork[i].id
              const fileId = listWork[i].user_file_id
              if (fileId !== 0) {
                apiCommon
                  .fetchFile({ file_id: fileId })
                  .then((res) => {
                    getDataURL(res).then((dataUrl) => {
                      for (let k = 0; k < listWork.length; k++) {
                        if (listWork[k].id === id) {
                          listWork[k].image = dataUrl
                          break
                        }
                      }
                    })
                  })
              }
            }
            group1.list = listWork

          }
        })      
    },

    /**
     * ノートタイトルをクリック
     */
    onNoteClicked: (noteId) => {

      store.dispatch('search/setNoteSearchParam', { id: noteId })

      if (store.state.common.device === 'sp') {
        router.push({ name: 'SPNoteEdit', params: { note_id: noteId } })
      } else {
        router.push({ name: 'PCNoteList' })
      }
    }
    
  })

  return group1
}
